import { normalizeAppPath } from "./normalizeAppPath";

const EXACT_PUBLIC = new Set([
  "/",
  "/unauthorized",
  "/exhibition-form",
  "/forgot-password",
  "/reset-password",
  "/mfa-verify",
]);

/**
 * True for routes where users may have no valid session; background 401s must not redirect to login.
 */
export function isPublicAnonymousRoute(pathname) {
  const p = normalizeAppPath(pathname || "/");
  if (EXACT_PUBLIC.has(p)) return true;
  if (p.startsWith("/lecturer-attendance")) return true;
  if (p.startsWith("/book/") || p === "/book") return true;
  if (p.startsWith("/register/")) return true;
  return false;
}
